import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getFirestore, doc, updateDoc } from "firebase/firestore";
import { getAuth, updatePassword, reauthenticateWithCredential, EmailAuthProvider } from "firebase/auth";

const passwordRules = [
  { regex: /.{6,}/, message: "Mindestens 6 Zeichen" },
  { regex: /[A-Za-z]/, message: "Mindestens ein Buchstabe" },
  { regex: /[0-9]/, message: "Mindestens eine Zahl" },
  { regex: /[^A-Za-z0-9]/, message: "Mindestens ein Sonderzeichen" },
];

const ChangePassword = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [showHints, setShowHints] = useState(false);
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();
  const db = getFirestore();
  const auth = getAuth();

  const validatePassword = (pw) => {
    for (const rule of passwordRules) {
      if (!rule.regex.test(pw)) return rule.message;
    }
    return null;
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setShowHints(false);

    if (!currentPassword || !newPassword || !confirmPassword) {
      setError("Bitte alle Felder ausfüllen.");
      setShowHints(true);
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Die neuen Passwörter stimmen nicht überein.");
      setShowHints(true);
      return;
    }
    const pwError = validatePassword(newPassword);
    if (pwError) {
      setError(`Neues Passwort: ${pwError}.`);
      setShowHints(true);
      return;
    }
    const user = auth.currentUser;
    if (!user || !user.email) {
      setError("Kein Benutzer angemeldet. Bitte erneut einloggen.");
      return;
    }
    // Re-Authentifizierung mit aktuellem Passwort
    const credential = EmailAuthProvider.credential(user.email, currentPassword);
    try {
      await reauthenticateWithCredential(user, credential);
      await updatePassword(user, newPassword);
      // Optional: Firestore-Feld aktualisieren
      const userStr = localStorage.getItem("currentUser");
      let userId = null;
      if (userStr) {
        try {
          const userObj = JSON.parse(userStr);
          userId = userObj.id || userObj.uid;
        } catch {}
      }
      if (userId) {
        const userRef = doc(db, "users", userId);
        await updateDoc(userRef, {
          password: newPassword,
          mustChangePasswort: false,
        });
      }
      setSuccess("Passwort erfolgreich geändert.");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
      setShowHints(false);
      setTimeout(() => navigate("/home"), 1500);
    } catch (err) {
      if (err.code === "auth/wrong-password") {
        setError("Das aktuelle Passwort ist falsch.");
      } else if (err.code === "auth/weak-password") {
        setError("Das neue Passwort ist zu schwach.");
      } else {
        setError(err.message || "Fehler beim Ändern des Passworts.");
      }
      setShowHints(true);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-start", minHeight: "100vh", background: "#fff" }}>
      <form onSubmit={handleChangePassword} style={{ background: "#fff", padding: 24, borderRadius: 8, boxShadow: "0 2px 12px rgba(0,0,0,0.07)", width: 400, marginTop: 48 }}>
        <h2 style={{ fontSize: 22, fontWeight: 600, marginBottom: 18, textAlign: "center" }}>Passwort ändern</h2>
        {error && <p style={{ color: "#d32f2f", fontSize: 15, marginBottom: 10 }}>{error}</p>}
        {success && <p style={{ color: "#388e3c", fontSize: 15, marginBottom: 10 }}>{success}</p>}
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <input
            type="password"
            placeholder="Aktuelles Passwort"
            value={currentPassword}
            onChange={e => setCurrentPassword(e.target.value)}
            required
            style={{ width: "100%", padding: "10px", border: "1px solid #ccc", borderRadius: 4, fontSize: 16 }}
          />
          <input
            type="password"
            placeholder="Neues Passwort"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
            required
            style={{ width: "100%", padding: "10px", border: "1px solid #ccc", borderRadius: 4, fontSize: 16 }}
          />
          <input
            type="password"
            placeholder="Neues Passwort bestätigen"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            required
            style={{ width: "100%", padding: "10px", border: "1px solid #ccc", borderRadius: 4, fontSize: 16 }}
          />
        </div>
        <button
          type="submit"
          style={{ width: "100%", background: "#1976d2", color: "white", border: "none", borderRadius: 4, padding: "12px", fontSize: 17, fontWeight: 600, marginTop: 18, cursor: "pointer" }}
        >
          Passwort ändern
        </button>
        {showHints && (
          <div style={{ background: "#e3f0ff", borderRadius: 6, padding: 16, marginTop: 18, fontSize: 15 }}>
            <strong>Hinweise zur Passwortsicherheit</strong>
            <ul style={{ margin: "8px 0 0 18px", padding: 0 }}>
              <li>Verwenden Sie mindestens 6 Zeichen</li>
              <li>Kombinieren Sie Buchstaben, Zahlen und Sonderzeichen</li>
              <li>Vermeiden Sie leicht zu erratende Passwörter wie Namen oder Geburtsdaten</li>
              <li>Verwenden Sie für jedes Konto ein eigenes Passwort</li>
            </ul>
          </div>
        )}
      </form>
    </div>
  );
};

export default ChangePassword;
